var map = {
	"./de/general5/slide1.svg": 747362,
	"./en/general5/slide1.svg": 378134,
	"./es/general5/slide1.svg": 87899,
	"./fr/general5/slide1.svg": 984627,
	"./nl/general5/slide1.svg": 544229,
	"./pt/general5/slide1.svg": 62023
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 848788;